
export function unite(list1: any[], list2: any[]): any[] {
    return [...list1, ...list2]
}